import {dailyMakeup, levels, occasions, timesOfDay, vibes} from 'pages/Questionnaire/answers'

const cannedLookIds = {
  caramelMuse: 44986,
  classicRed: 51008,
  date: 51038,
  daylightCharm: 51056,
  elegantRedBeige: 42713,
  glitterStars: 51029,
  icyLook: 48990,
  goldenGlam: 48994,
  mermaid: 44984,
  mysticSmokey: 51047,
  pinkDream: 51001,
  redHot: 44985,
  sizzle: 44982,
  smokeyChic: 50993,
  smokeyGlam: 51057,

  testBurgundyShimmer14: 42717,
  testMetallicOlive16: 42731,
}
const mbpaLookIds = {
  noMakeupMakeup: 52961,
  boyfriendBlush: 52963,
  beachBronzeCasual: 52965,
  beachBronzeGlam: 52968,
  softGlam: 52969,
  smokeyFullGlam: 52971,
  wingedEyeGlam: 52973,
  wingedEyeCasual: 52974,
  // colouredEyelinerGlam: ,
  // colouredEyelinerCasual: ,
  boldLipGlam: 52977,
  boldLipCasual: 52978,
}

const allOccasionsExceptCocktail = [
  occasions.wedding, occasions.work, occasions.workEvent, occasions.date
]
const allOccasions = [occasions.cocktail, ...allOccasionsExceptCocktail]

const anyLevel = [levels.beginner, levels.intermediate, levels.advanced]

export const looks = {
  mbpa_1_noMakeupMakeup: {
    id: mbpaLookIds.noMakeupMakeup,
    vibes: [vibes.effortless, vibes.casual],
    occasions: allOccasionsExceptCocktail,
    skillLevels: anyLevel,
    makeupAmount: [dailyMakeup.minimal, dailyMakeup.basic],
    timesOfDay: [timesOfDay.day],
  },
  mbpa_2_boyfriendBlush: {
    id: mbpaLookIds.boyfriendBlush,
    vibes: [vibes.effortless, vibes.casual],
    occasions: allOccasionsExceptCocktail,
    skillLevels: anyLevel,
    makeupAmount: [dailyMakeup.minimal, dailyMakeup.basic],
    timesOfDay: [timesOfDay.afternoon, timesOfDay.night],
  },
  mbpa_3_beachBronzeCasual: {
    id: mbpaLookIds.beachBronzeCasual,
    vibes: [vibes.casual],
    occasions: allOccasionsExceptCocktail,
    skillLevels: anyLevel,
    makeupAmount: [dailyMakeup.minimal, dailyMakeup.basic, dailyMakeup.minimalPlus],
    timesOfDay: [timesOfDay.day],
  },
  mbpa_3a_beachBronzeGlam: {
    id: mbpaLookIds.beachBronzeGlam,
    vibes: [vibes.sophisticated, vibes.sexy, vibes.glam],
    occasions: allOccasions,
    skillLevels: [levels.intermediate, levels.advanced],
    makeupAmount: [dailyMakeup.full, dailyMakeup.minimalPlus],
    timesOfDay: [timesOfDay.afternoon, timesOfDay.night],
  },
  mbpa_4_softGlam: {
    id: mbpaLookIds.softGlam,
    vibes: [vibes.sophisticated, vibes.sexy, vibes.glam],
    occasions: allOccasions,
    skillLevels: [levels.intermediate, levels.advanced],
    makeupAmount: [dailyMakeup.minimal, dailyMakeup.basic, dailyMakeup.minimalPlus],
    timesOfDay: [timesOfDay.afternoon, timesOfDay.night],
  },
  mbpa_5_smokeyFullGlam: {
    id: mbpaLookIds.smokeyFullGlam,
    vibes: [vibes.sophisticated, vibes.sexy, vibes.glam],
    occasions: allOccasions,
    skillLevels: [levels.advanced],
    makeupAmount: [dailyMakeup.full],
    timesOfDay: [timesOfDay.night],
  },
  mbpa_6_wingedEyeGlam: {
    id: mbpaLookIds.wingedEyeGlam,
    vibes: [vibes.sophisticated, vibes.sexy, vibes.glam, vibes.effortless],
    occasions: allOccasions,
    skillLevels: [levels.advanced],
    makeupAmount: [dailyMakeup.full],
    timesOfDay: [timesOfDay.afternoon, timesOfDay.night],
  },
  mbpa_6a_wingedEyeCasual: {
    id: mbpaLookIds.wingedEyeCasual,
    vibes: [vibes.effortless, vibes.casual],
    occasions: allOccasions,
    skillLevels: [levels.intermediate, levels.advanced],
    makeupAmount: [dailyMakeup.minimal, dailyMakeup.basic, dailyMakeup.minimalPlus],
    timesOfDay: [timesOfDay.day],
  },
  // mbpa_7_colouredEyelinerGlam: {
  //   id: cannedLookIds.mermaid, //      *
  //   vibes: [vibes.sexy, vibes.glam],
  //   occasions: allOccasions,
  //   skillLevels: [levels.advanced],
  //   makeupAmount: [dailyMakeup.full],
  //   timesOfDay: [timesOfDay.afternoon, timesOfDay.night],
  // },
  // mbpa_7a_colouredEyelinerCasual: {
  //   id: cannedLookIds.sizzle, //       *
  //   vibes: [vibes.effortless, vibes.casual],
  //   occasions: allOccasions,
  //   skillLevels: [levels.intermediate, levels.advanced],
  //   makeupAmount: [dailyMakeup.minimal, dailyMakeup.basic, dailyMakeup.minimalPlus],
  //   timesOfDay: [timesOfDay.afternoon, timesOfDay.night],
  // },
  mbpa_8_boldLipGlam: {
    id: mbpaLookIds.boldLipGlam,
    vibes: [vibes.sophisticated, vibes.sexy, vibes.glam],
    occasions: allOccasions,
    skillLevels: [levels.advanced],
    makeupAmount: [dailyMakeup.minimal, dailyMakeup.basic, dailyMakeup.minimalPlus],
    timesOfDay: [timesOfDay.afternoon, timesOfDay.night],
  },
  mbpa_8a_boldLipCasual: {
    id: mbpaLookIds.boldLipCasual,
    vibes: [vibes.effortless, vibes.casual],
    occasions: allOccasions,
    skillLevels: [levels.intermediate, levels.advanced],
    makeupAmount: [dailyMakeup.minimal, dailyMakeup.basic, dailyMakeup.minimalPlus],
    timesOfDay: [timesOfDay.day, timesOfDay.afternoon, timesOfDay.night],
  },
}

export const allLookIds = new Set(Object.entries(looks).map(([_, {id}]) => id))

export const skillLevelLookIds = Object.fromEntries(Object.entries(levels).map(([_, v]) => [
  v,
  new Set(
    Object.entries(looks)
      .filter(([_, {skillLevels}]) => skillLevels.includes(v))
      .map(([_, {id}]) => id),
  ),
]))

export const vibeLookIds = Object.fromEntries(Object.entries(vibes).map(([_, v]) => [
  v,
  new Set(
    Object.entries(looks)
      .filter(([_, {vibes: lookVibes}]) => lookVibes.includes(v))
      .map(([_, {id}]) => id),
  ),
]))

export const occasionLookIds = Object.fromEntries(Object.entries(occasions).map(([_, v]) => [
  v,
  new Set(
    Object.entries(looks)
      .filter(([_, {occasions: lookOccassions}]) => lookOccassions.includes(v))
      .map(([_, {id}]) => id),
  ),
]))

export const dailyMakeupLookIds = Object.fromEntries(Object.entries(dailyMakeup).map(([_, v]) => [
  v,
  new Set(
    Object.entries(looks)
      .filter(([_, {makeupAmount}]) => makeupAmount.includes(v))
      .map(([_, {id}]) => id),
  ),
]))

export const timeOfDayLookIds = Object.fromEntries(Object.entries(timesOfDay).map(([_, v]) => [
  v,
  new Set(
    Object.entries(looks)
      .filter(([_, {timesOfDay: lookTimesOfDay}]) => lookTimesOfDay.includes(v))
      .map(([_, {id}]) => id),
  ),
]))
